module.exports = __webpack_public_path__ + "static/media/2.ce3f5df9.jpg";